import {
    Box,
    Heading,
    SimpleGrid,
    VStack
} from '@chakra-ui/react';
import { hasPermission } from '../Utils';
import AppsDownloadWidget from './Dashboard/AppsDownloadWidget';
import ClientsOrdersWidgets from './Dashboard/ClientsOrdersWidgets';
import CouriersNeedUpdate from './Dashboard/CouriersNeedUpdate';
import OrdersStatsChart from './Dashboard/OrdersStatsChart';
import PickupsStatsChart from './Dashboard/PickupsStatsChart';
import WorkingCouriersWidget from './Dashboard/WorkingCouriersWidget';

const Dashboard = () => {
    return (
        <Box maxW="full" mx="auto" p={8}>
            <VStack spacing={8} align="stretch">
                <Heading>Dashboard</Heading>



                {hasPermission("clientOrderWidget") && (
                    <>
                        <ClientsOrdersWidgets />
                    </>
                )}



                {hasPermission("couriersWidget") && (
                    <>
                        <WorkingCouriersWidget />
                    </>
                )}


                {hasPermission("couriersWidget") && (

                    <>
                        <SimpleGrid columns={{ base: 1, lg: 10 }} spacing={4}>
                            {/* 30% */}
                            <Box gridColumn={{ base: "1 / -1", lg: "span 3" }}>
                                <AppsDownloadWidget />
                            </Box>

                            {/* 70% */}
                            <Box gridColumn={{ base: "1 / -1", lg: "span 7" }}>
                                <CouriersNeedUpdate />
                            </Box>
                        </SimpleGrid>
                    </>
                )}


                <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={4}>
                    {hasPermission("clientOrderWidget") && (
                        <Box>
                            <OrdersStatsChart />
                        </Box>
                    )}

                    {hasPermission("couriersWidget") && (
                        <Box>
                            <PickupsStatsChart />
                        </Box>
                    )}
                </SimpleGrid>

            </VStack>
        </Box>
    );
};

export default Dashboard;
